'use strict';

exports.decode = require('./decode');
